// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"aa8cebbe","704":"5b457a25","769":"ab2db72a","787":"d27c9d20","893":"7ac27b9b"}[chunkId] + ".chunk.js";
};